var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { Modal } from './Modal';
import { SearchInput } from '../CurrencyInput/SearchInput';
import styled from 'styled-components';
import { customScrollBar } from '../cssTemplates/ScrollBar';
var OptionsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: auto;\n  height: ", ";\n\n  ", "\n"], ["\n  overflow: auto;\n  height: ", ";\n\n  ", "\n"])), function (props) { return (props.searchEnabled ? 'calc(100% - 106px)' : '100%'); }, customScrollBar);
export function ListModal(_a) {
    var label = _a.label, onClose = _a.onClose, isOpen = _a.isOpen, searchPlaceholder = _a.searchPlaceholder, filterItems = _a.filterItems, list = _a.list, renderItems = _a.renderItems;
    var _b = useState(''), searchString = _b[0], setSearchString = _b[1];
    var handleSearchChange = useCallback(function (e) {
        setSearchString(e.target.value);
    }, []);
    var handleClose = useCallback(function () {
        setSearchString('');
        onClose();
    }, [onClose]);
    var resultArray = useMemo(function () {
        if (!searchString || !filterItems) {
            return list;
        }
        return list.filter(function (item) { return filterItems(item, searchString); });
    }, [list, searchString, filterItems]);
    return (_jsxs(Modal, __assign({ onClose: handleClose, label: label, isOpen: isOpen }, { children: [Boolean(filterItems) && (_jsx("div", { children: _jsx(SearchInput, { value: searchString, onChange: handleSearchChange, autoFocus: true, placeholder: searchPlaceholder }) })), _jsx(OptionsWrapper, __assign({ searchEnabled: Boolean(filterItems) }, { children: resultArray.map(renderItems) }))] })));
}
var templateObject_1;
